// extracted by mini-css-extract-plugin
module.exports = {"iframe":"BandcampPlayer_iframe__2j8Sl","playerContainer":"BandcampPlayer_playerContainer__17uoX","loaderContainer":"BandcampPlayer_loaderContainer__3prDT"};